/**
 * M64 Reveal Controller Section
 * Handles looping controller video that swaps based on selected color
 */

const M64Controller = {
  elements: {
    videos: null
  },
  
  currentColor: null,
  
  init() {
    this.elements.videos = document.querySelectorAll('.m64-controller__video');
    this.bindEvents();
  },
  
  bindEvents() {
    document.addEventListener('m64ColorSelected', (e) => {
      this.setActiveColor(e.detail.color);
    });
  },
  
  setActiveColor(color) {
    if (this.currentColor === color) return;
    
    this.elements.videos.forEach(video => {
      const isActive = video.dataset.color === color;
      
      if (isActive) {
        video.classList.add('is-active');
        video.play().catch(() => {});
      } else {
        video.classList.remove('is-active');
        video.pause();
        video.currentTime = 0;
      }
    });
    
    this.currentColor = color;
  }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => M64Controller.init());
} else {
  M64Controller.init();
}

// Expose for debugging
window.M64Controller = M64Controller;